import React from 'react';
import styles from './styles/styles.module.scss';
import { string, func } from 'prop-types';
import expandIcon from '../../../../assets/images/icons/share/map-expand@2x.png';
import { wrapEventHandler } from '../../../utils/handlers';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const StaticMapImage = ({ url, onClick }) => {
  return (
    <a className={styles.container} href={url} onClick={wrapEventHandler(onClick)}>
      <img className={styles.staticMapImage} src={url} alt={'mapping routes'} />
      <div className={styles.viewFullMap}>
        <div>{StringConstantsMixin.strings.VIEW_FULL_MAP}</div> <img src={expandIcon} alt={'expand'} />
      </div>
    </a>
  );
};

StaticMapImage.propTypes = {
  url: string.isRequired,
  onClick: func.isRequired
};

export default StaticMapImage;
